<template>
  <div>
    <form-datepicker
      :value="selectedDate"
      index="test"
      type="datetime"
      @input="selectedDateChanged" />
    <div>
      <h3>ITEM JSON</h3>
      <p class="responseText">
        {{ selectedDate }}
        {{ formatedDate }}
      </p>
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import moment from 'moment'

export default {
  name: 'Playground',
  mixins: [Helpers],
  data () {
    return {
      responseText: '',
      selectedDate: moment().toISOString(true),
      formatedDate: ''
    }
  },
  methods: {
    selectedDateChanged (value, index) {
      if (value) {
        this.selectedDate = value
        this.formatedDate = moment(this.selectedDate).format('YYYY-MM-DD HH:mm')
      }
    }
  }
}
</script>
<style lang="scss">
  p {
    white-space: pre-wrap;
  }
</style>
